/* Bruma · botón de ayuda como el de Jolie, pero las conversaciones van a WhatsApp (30 oct 2026).
   Preguntas rápidas con su respuesta aquí mismo; lo demás, «Escríbenos» abre WhatsApp con el mensaje ya escrito. */
(function () {
  if (window.__clxAyuda) return;
  window.__clxAyuda = true;
  // Decisión de Juan (30 oct 2026): ni en las fichas de producto ni en el carrito, porque despista al comprar.
  if (/(^|\/)(products|cart)(\/|$)/.test(location.pathname)) return;

  var TELEFONO = '34746042838';
  var PREGUNTAS = [
    { p: '¿Cuánto tarda el envío?', r: 'Enviamos gratis a toda la España peninsular. Llega en 5 a 8 días laborables y te mandamos el número de seguimiento por email.' },
    { p: '¿Cómo funciona la prueba de 30 días?', r: 'Tienes 30 días desde que la recibes para probarla en casa. Si no te convence, nos la devuelves gratis y te devolvemos el dinero.' },
    { p: '¿Cómo funciona la suscripción?', r: 'Te enviamos un filtro nuevo cada 3 meses por 29 € (suelto cuesta 36 €), con envío gratis. Sin permanencia: la pausas o cancelas cuando quieras.' },
    { p: '¿Sirve para mi ducha?', r: 'Sí, si tu ducha tiene brazo fijo. Lleva la rosca universal de 1/2 pulgada, la estándar en España, y se enrosca en el brazo de la pared o del techo. No va en el flexo de la ducha de mano.' },
    { p: '¿Cada cuánto cambio el filtro?', r: 'Cada 3 meses, más o menos, para que rinda al máximo. Si el agua de tu zona es muy dura o en casa sois muchos, antes.' },
    { p: 'Quiero cambiar o cancelar mi pedido', r: null }
  ];

  var css =
    '.clx-ay{position:fixed;right:24px;bottom:24px;z-index:900;font-family:Inter,"Helvetica Neue",Helvetica,Arial,sans-serif;color:#212121;letter-spacing:normal}' +
    '.clx-ay *{box-sizing:border-box}' +
    'body:has(.clx-cd.is-open) .clx-ay{display:none}' +
    '.clx-ay__lanzador{width:48px;height:48px;border-radius:9999px;border:0;background:#fff;box-shadow:0 2px 12px rgba(0,0,0,.15);display:flex;align-items:center;justify-content:center;cursor:pointer;transition:transform .3s cubic-bezier(.16,1,.3,1)}' +
    '.clx-ay__lanzador:hover{transform:scale(1.06)}.clx-ay__lanzador:active{transform:scale(.94)}' +
    '.clx-ay__panel{position:absolute;right:0;bottom:0;width:320px;height:min(560px,calc(100vh - 48px));height:min(560px,calc(100dvh - 48px));border-radius:24px;background:linear-gradient(180deg,#f4f4f5 0%,#e8e9eb 100%);box-shadow:0 8px 40px rgba(0,0,0,.18);display:flex;flex-direction:column;padding:16px;opacity:0;visibility:hidden;transform:translateY(12px) scale(.98);transform-origin:bottom right;transition:opacity .25s,transform .35s cubic-bezier(.16,1,.3,1),visibility 0s .35s}' +
    '.clx-ay.abierto .clx-ay__panel{opacity:1;visibility:visible;transform:none;transition:opacity .25s,transform .35s cubic-bezier(.16,1,.3,1)}' +
    '.clx-ay.abierto .clx-ay__lanzador{opacity:0;pointer-events:none}' +
    '.clx-ay__arriba{display:flex;justify-content:flex-end;gap:8px}' +
    '.clx-ay__icono{position:relative;width:32px;height:32px;border-radius:9999px;border:0;background:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;color:#212121}' +
    '.clx-ay__icono:hover{background:#f0f0f0}' +
    '.clx-ay__num{position:absolute;top:-3px;right:-3px;min-width:15px;height:15px;padding:0 4px;border-radius:9999px;background:#212121;color:#fff;font-size:9px;line-height:15px;text-align:center}' +
    '.clx-ay__marca{display:flex;justify-content:center;align-items:center;margin:8px 0 0;height:32px;flex:none}' +
    '.clx-ay__marca img,.clx-ay__marca svg{height:18px!important;max-height:18px!important;width:auto!important;max-width:100%!important}' +
    '.clx-ay__hilo{flex:1;min-height:0;overflow-y:auto;overscroll-behavior:contain;display:flex;flex-direction:column;gap:8px;padding:16px 2px 12px;scrollbar-width:thin}' +
    '.clx-ay__hilo>:first-child{margin-top:auto}' +
    '.clx-ay .clx-ay__chip--volver{background:transparent;border:1px solid #cfcfd2}' +
    '.clx-ay .clx-ay__chip--volver:hover{background:#fff}' +
    '@keyframes clxAyEntra{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}' +
    '.clx-ay__burbuja,.clx-ay__chip{animation:clxAyEntra .3s cubic-bezier(.16,1,.3,1) both}' +
    '@media (prefers-reduced-motion:reduce){.clx-ay__burbuja,.clx-ay__chip{animation:none}}' +
    '.clx-ay__chip{align-self:flex-start;max-width:100%;border:0;border-radius:9999px;background:#fff;padding:8px 14px;font:inherit;font-size:12px;line-height:1.35;text-align:left;color:#212121;cursor:pointer;transition:background-color .2s}' +
    '.clx-ay__chip:hover{background:#fafafa}' +
    '.clx-ay__burbuja{border-radius:16px;padding:10px 14px;font-size:12.5px;line-height:1.5}' +
    '.clx-ay__burbuja--yo{align-self:flex-end;background:#212121;color:#fff;max-width:85%}' +
    '.clx-ay__burbuja--bruma{align-self:flex-start;background:#fff;max-width:92%}' +
    '.clx-ay__wa{display:inline-flex;align-items:center;gap:6px;margin-top:8px;font-size:12px;color:#212121;text-decoration:underline;text-underline-offset:2px}' +
    '.clx-ay__escribir{display:flex;align-items:center;gap:8px;background:#fff;border-radius:9999px;padding:6px 6px 6px 16px}' +
    '.clx-ay__escribir input{flex:1;min-width:0;border:0;outline:0;background:transparent;font:inherit;font-size:13px;color:#212121}' +
    '.clx-ay__escribir input::placeholder{color:#8a8a8a}' +
    '.clx-ay__enviar{width:32px;height:32px;border-radius:9999px;border:0;background:#212121;color:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;flex:none}' +
    '.clx-ay__pie{margin-top:10px;text-align:center;font-size:10.5px;color:#6e6e6e}' +
    '.clx-ay__pie a{color:inherit;text-decoration:underline}' +
    '@media (max-width:749px){.clx-ay{right:16px;bottom:16px}.clx-ay__panel{position:fixed;right:8px;left:8px;bottom:8px;width:auto;height:min(560px,calc(100dvh - 16px))}}';

  var estilo = document.createElement('style');
  estilo.textContent = css;
  document.head.appendChild(estilo);

  var I_CHAT = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 3C6.9 3 3 6.6 3 11c0 2.2 1 4.2 2.6 5.6L5 21l4.3-2.2c.9.3 1.8.4 2.7.4 5.1 0 9-3.6 9-8.1S17.1 3 12 3Z" fill="#212121"/><circle cx="8" cy="11" r="1.2" fill="#fff"/><circle cx="12" cy="11" r="1.2" fill="#fff"/><circle cx="16" cy="11" r="1.2" fill="#fff"/></svg>';
  var I_CARRITO = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M3 4h2l2.2 10.5h11L20 7H6.2"/><circle cx="9" cy="19" r="1.4"/><circle cx="17" cy="19" r="1.4"/></svg>';
  var I_CERRAR = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  var I_ENVIAR = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  var I_WA = '<svg width="14" height="14" viewBox="0 0 24 24" fill="#212121" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Zm5.3 14.1c-.2.6-1.3 1.2-1.8 1.2-.5.1-1 .2-3.3-.7-2.8-1.1-4.6-4-4.7-4.2-.1-.2-1.1-1.5-1.1-2.9s.7-2 1-2.3c.2-.3.5-.3.7-.3h.5c.2 0 .4 0 .6.5l.8 2c.1.2.1.4 0 .5l-.4.6-.4.4c-.1.1-.3.3-.1.6.2.3.8 1.3 1.7 2.1 1.2 1 2.1 1.4 2.4 1.5.3.2.5.1.6-.1l.9-1c.2-.3.4-.2.6-.1l2 .9c.3.1.5.2.5.3.1.2.1.8-.1 1.3Z"/></svg>';

  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function enlaceWa(texto) { return 'https://wa.me/' + TELEFONO + '?text=' + encodeURIComponent(texto); }

  var raiz = document.createElement('div');
  raiz.className = 'clx-ay';
  raiz.innerHTML =
    '<div class="clx-ay__panel" role="dialog" aria-label="Ayuda de Bruma Origin" aria-modal="false">' +
      '<div class="clx-ay__arriba">' +
        '<button type="button" class="clx-ay__icono" data-ay="carrito" aria-label="Ver el carrito">' + I_CARRITO + '<span class="clx-ay__num" hidden></span></button>' +
        '<button type="button" class="clx-ay__icono" data-ay="cerrar" aria-label="Cerrar la ayuda">' + I_CERRAR + '</button>' +
      '</div>' +
      '<div class="clx-ay__marca"></div>' +
      '<div class="clx-ay__hilo" aria-live="polite"></div>' +
      '<form class="clx-ay__escribir">' +
        '<input type="text" name="m" placeholder="Escríbenos por WhatsApp" aria-label="Tu mensaje para WhatsApp" autocomplete="off">' +
        '<button type="submit" class="clx-ay__enviar" aria-label="Enviar por WhatsApp">' + I_ENVIAR + '</button>' +
      '</form>' +
      '<p class="clx-ay__pie">Te respondemos por WhatsApp, de lunes a viernes de 8:00 a 21:00 · <a href="/policies/privacy-policy">Privacidad</a></p>' +
    '</div>' +
    '<button type="button" class="clx-ay__lanzador" data-ay="abrir" aria-label="Abrir la ayuda" aria-expanded="false">' + I_CHAT + '</button>';
  document.body.appendChild(raiz);

  var panel = raiz.querySelector('.clx-ay__panel');
  var hilo = raiz.querySelector('.clx-ay__hilo');
  var lanzador = raiz.querySelector('.clx-ay__lanzador');
  var entrada = raiz.querySelector('input');
  var num = raiz.querySelector('.clx-ay__num');

  // logo: el mismo de la cabecera
  var logo = document.querySelector('header a[href="/"] svg, header a[href="/"] img, .header a[href="/"] svg, .header a[href="/"] img');
  var marca = raiz.querySelector('.clx-ay__marca');
  if (logo) marca.appendChild(logo.cloneNode(true));
  else marca.innerHTML = '<strong style="font-size:15px;letter-spacing:.08em">BRUMA ORIGIN</strong>';

  function pintarChips() {
    PREGUNTAS.forEach(function (q, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'clx-ay__chip';
      b.textContent = q.p;
      b.dataset.i = i;
      hilo.appendChild(b);
    });
  }
  pintarChips();

  function burbuja(texto, quien, html) {
    var d = document.createElement('div');
    d.className = 'clx-ay__burbuja clx-ay__burbuja--' + quien;
    if (html) d.innerHTML = html; else d.textContent = texto;
    hilo.appendChild(d);
    hilo.scrollTop = hilo.scrollHeight;
  }

  function preguntas() {
    hilo.innerHTML = '';
    pintarChips();
    hilo.scrollTop = hilo.scrollHeight;
  }

  hilo.addEventListener('click', function (e) {
    if (e.target.closest('.clx-ay__chip--volver')) { preguntas(); return; }
    var b = e.target.closest('.clx-ay__chip');
    if (!b) return;
    var q = PREGUNTAS[+b.dataset.i];
    hilo.innerHTML = '';
    burbuja(q.p, 'yo');
    var texto = q.r || 'Claro. Escríbenos por WhatsApp con tu número de pedido y lo vemos enseguida.';
    var wa = q.r ? 'Hola, tengo una duda: ' + q.p : 'Hola, quiero cambiar o cancelar mi pedido. Mi número de pedido es: ';
    setTimeout(function () {
      burbuja('', 'bruma', esc(texto) + '<br><a class="clx-ay__wa" href="' + enlaceWa(wa) + '" target="_blank" rel="noopener">' + I_WA + (q.r ? '¿Otra duda? Escríbenos por WhatsApp' : 'Abrir WhatsApp') + '</a>');
      var v = document.createElement('button');
      v.type = 'button';
      v.className = 'clx-ay__chip clx-ay__chip--volver';
      v.textContent = '← Ver otras preguntas';
      hilo.appendChild(v);
      hilo.scrollTop = 0;
    }, 300);
  });

  raiz.querySelector('form').addEventListener('submit', function (e) {
    e.preventDefault();
    var t = entrada.value.trim();
    window.open(enlaceWa(t || 'Hola, tengo una duda sobre Bruma Origin.'), '_blank', 'noopener');
    entrada.value = '';
  });

  function contar() {
    fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { num.hidden = !c.item_count; num.textContent = c.item_count; })
      .catch(function () {});
  }

  function abrir() {
    raiz.classList.add('abierto');
    lanzador.setAttribute('aria-expanded', 'true');
    contar();
    setTimeout(function () { (raiz.querySelector('.clx-ay__chip') || entrada).focus(); }, 50);
  }
  function cerrar() {
    raiz.classList.remove('abierto');
    lanzador.setAttribute('aria-expanded', 'false');
    lanzador.focus();
  }

  raiz.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ay]');
    if (!a) return;
    var que = a.dataset.ay;
    if (que === 'abrir') abrir();
    else if (que === 'cerrar') cerrar();
    else if (que === 'carrito') {
      cerrar();
      if (window.clxCarrito) window.clxCarrito.abrir(); else location.href = '/cart';
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && raiz.classList.contains('abierto')) cerrar(); });
  document.addEventListener('click', function (e) { if (raiz.classList.contains('abierto') && e.composedPath().indexOf(raiz) < 0) cerrar(); });
})();
